function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import InputBase from "@mui/material/InputBase";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
// @limitless
import SearchIcon from "@limitless/icons/Search";
import CloseIcon from "@limitless/icons/Close";
import { useTranslation } from "@limitless/common/hooks";
import InputLabel from "../input-label/InputLabel";
const SearchInputBase = styled(InputBase)(({
  variant,
  theme
}) => {
  const variantStyle = variant === "standard" && {
    "&.MuiInputBase-root": {
      border: 0,
      borderBottom: `1px solid ${theme.palette.grey[1]}`,
      padding: 0,
      marginTop: 0,
      height: "32px",
      borderRadius: 0,
      "&::before": {
        borderBottom: `1px solid ${theme.palette.grey[1]}`
      },
      "&::after": {
        borderBottom: `1px solid ${theme.palette.primary.main}`
      }
    },
    "&.MuiInput-underline": {
      "&&:hover::before": {
        borderBottom: `1px solid ${theme.palette.grey[1]}`
      }
    }
  };
  return {
    ...variantStyle,
    "&.Mui-focused": {
      borderColor: theme.palette.primary.light
    }
  };
});
const SearchInput = ({
  value,
  placeholder = "Search here",
  fullWidth = true,
  id = "searchTextField",
  clearSearch,
  onSubmit,
  onChange,
  label,
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  const [isSearched, setIsSearched] = React.useState(false);
  const [focus, setFocus] = React.useState(false);
  const [isValid, setIsValid] = React.useState(false);
  const inputRef = React.useRef();
  React.useEffect(() => {
    if (value !== "") {
      setIsSearched(true);
    }
  }, []);
  React.useEffect(() => {
    if (focus) {
      inputRef.current.focus();
    }
  }, [focus]);
  React.useEffect(() => {
    if (isSearched) {
      setIsSearched(false);
    }
    if (value.length > 2) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [value]);
  const handleInputChange = e => {
    let searchTerm = e.target.value;
    if (typeof onChange === "function") {
      onChange(searchTerm);
    }
    searchTerm = searchTerm.trim();
    if (e.which === 13 || e.keyCode === 13) {
      if (onSubmit) {
        handleSearchClick();
      }
    }
  };
  const handleSearchClick = () => {
    if (isValid) {
      setIsSearched(true);
      onSubmit(value);
      setFocus(true);
    }
  };
  return /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: fullWidth,
    sx: {
      marginBottom: 0
    }
  }, label && /*#__PURE__*/React.createElement(InputLabel, {
    label: label,
    id: id
  }), /*#__PURE__*/React.createElement(SearchInputBase, _extends({
    id: id,
    placeholder: t(placeholder),
    value: value,
    autoComplete: "off",
    endAdornment: !isSearched ? /*#__PURE__*/React.createElement(SearchIcon, {
      sx: {
        cursor: focus && isValid ? "pointer" : "inherit",
        color: theme => focus && isValid ? theme.palette.primary.main : theme.palette.primary.dark
      },
      onClick: handleSearchClick
    }) : /*#__PURE__*/React.createElement(CloseIcon, {
      viewBox: "0 0 14 14",
      sx: {
        height: 12,
        cursor: "pointer",
        color: theme => focus ? theme.palette.primary.main : theme.palette.primary.dark
      },
      onClick: () => {
        setIsSearched(false);
        clearSearch();
      }
    }),
    sx: {}
  }, rest, {
    onChange: handleInputChange,
    onKeyPress: handleInputChange,
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    inputRef: inputRef,
    "aria-labelledby": `${id}-label`
  })));
};
SearchInput.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  clearSearch: PropTypes.func,
  onSubmit: PropTypes.func,
  label: PropTypes.string,
  onChange: PropTypes.func
};
export default SearchInput;